export const GIFT_HOSPITALITY_DONATION_DUBLIN_SECTION_KEYS = {
  giftHospitalityDonationDublinRequestDetails: 'gift_hospitality_donation_dublin_request_details',
  giftHospitalityDonationDublinApproval: 'gift_hospitality_donation_dublin_approval',
} as const;

export const GIFT_HOSPITALITY_DONATION_DUBLIN_SECTION_TITLES = {
  giftHospitalityDonationDublinRequestDetails: 'Request Details',
  giftHospitalityDonationDublinApproval: 'Approval',
} as const;
